// ===================================================================
// src/app/App.tsx
//
// Root da aplicação. AuthProvider envolve tudo para que
// qualquer componente possa usar useAuth().
// ===================================================================

import { RouterProvider } from 'react-router';
import { router } from './routes';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/sonner';
import { ConfirmDialogProvider } from './hooks/useConfirm';
import { ChunkErrorBoundary } from './components/common/ChunkErrorBoundary';
import * as Sentry from '@sentry/react';

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0a0b0d]">
          <div className="text-center max-w-md p-8">
            <h1 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-2">
              Algo deu errado
            </h1>
            <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
              O erro foi registrado automaticamente. Recarregue a página
              ou entre em contato com o suporte se o problema persistir.
            </p>
            <button
              onClick={resetError}
              className="px-4 py-2 bg-indigo-600 text-white text-sm rounded-lg
                         hover:bg-indigo-700 transition-colors"
            >
              Tentar novamente
            </button>
          </div>
        </div>
      )}
    >
      <ThemeProvider>
        <AuthProvider>
          <PermissionProvider>
            <ChunkErrorBoundary>
              <RouterProvider router={router} />
            </ChunkErrorBoundary>
            <Toaster />
            <ConfirmDialogProvider />
          </PermissionProvider>
        </AuthProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
